import templateUrl from "emun.invoice/credit-request/credit-request-lines-header.htm";

export default () => ({ templateUrl });
